import React, { useContext } from "react";
import { WalletTodayMovementsContext } from "../../context";
import { Loader } from "components/loader";
import { EntitiesList, Pagination } from "components/entities-list";
import {
  formatMovementList,
  formatMovementPhoneList,
} from "../movements-list-item";

export const HistoryModel = ({ phoneView, className }) => {
  const {
    state: { loading, transfers, nextPageExist, currentPage },
  } = useContext(WalletTodayMovementsContext);
  if (loading) return <Loader />;

  const handleSelection = (event) => {
    event.preventDefault();
  };
  const handlePageUp = (event) => {
    event.preventDefault();
  };
  const handlePageDown = (event) => {
    event.preventDefault();
  };
  return (
    <div className={className}>
      <EntitiesList
        viewState={null}
        entities={transfers}
        formattingFunction={
          phoneView ? formatMovementPhoneList : formatMovementList
        }
        selectionHandler={handleSelection}
      >
        <Pagination
          padding="0 0 0.8rem 0"
          nextPageExist={nextPageExist}
          currentPage={currentPage}
          handlePageUp={handlePageUp}
          handlePageDown={handlePageDown}
        />
      </EntitiesList>
    </div>
  );
};
